import Image from 'next/image'

import { useQueryClient } from '@tanstack/react-query'
import { UseFormReturn } from 'react-hook-form'
import { FormattedMessage } from 'react-intl'

import {
  DeviceFilterStore,
  useDeviceFilterStore
} from '@/hooks/stores/useDeviceFilterStore'

import Button from '@/components/Button'

const ShopEmptyBoard = ({
  form: { reset: resetForm }
}: {
  form: UseFormReturn<DeviceFilterStore>
}) => {
  const { reset: resetStore } = useDeviceFilterStore()
  const queryClient = useQueryClient()

  const handleReset = async () => {
    resetForm()
    resetStore()

    await queryClient.invalidateQueries({
      queryKey: ['marketplace-devices']
    })
  }

  return (
    <div className="m-auto max-w-[392px] p-4 pb-5 tablet:py-5">
      <div className="flex flex-col items-center text-center">
        <div className="mb-4 h-[140px] flex-none desktop:h-[160px]">
          <Image
            className="block h-full w-auto"
            alt="Empty Shop List"
            height={160}
            priority
            src="/images/dog-search.svg"
            width={99}
          />
        </div>
        <h3 className="mb-2 text-x-md font-medium leading-x-md tablet:text-xl tablet:leading-xl">
          <FormattedMessage
            {...{
              id: 'shop.filter.results.empty.title',
              defaultMessage: 'По вашему запросу ничего не найдено'
            }}
          />
        </h3>
        <p className="mb-4 text-x-base leading-x-base">
          <FormattedMessage
            {...{
              id: 'shop.filter.results.empty.text',
              defaultMessage: 'Попробуйте поменять настройки в фильтре'
            }}
          />
        </p>
        <Button className="px-7" onClick={handleReset} variant="secondary">
          <FormattedMessage
            {...{
              id: 'shop.button.resetFilters',
              defaultMessage: 'Сбросить все фильтры'
            }}
          />
        </Button>
      </div>
    </div>
  )
}

export default ShopEmptyBoard
